/**
 * Category colours.
 *
 * Credit Note was `#0263ff`, a blue sitting right beside Invoice's `#8e30ff`
 * violet. As 8px dots in a table column those two read as the same mark —
 * neighbouring hues at similar lightness, and the pair most people with a
 * red-green deficiency also struggle to separate. Teal moves it to the far side
 * of the wheel: distinct from the violet, and from Sample Invoice's orange.
 */
const INVOICE_CATEGORY_DEFS = [
  { key: "INVOICE", id: 1, name: "Invoice", color: "#8e30ff" },
  { key: "CREDIT_NOTE", id: 2, name: "Credit Note", color: "#0d9488" },
  { key: "SAMPLE_INVOICE", id: 3, name: "Sample Invoice", color: "#ff7723" },
];

export const INVOICE_CATEGORIES = INVOICE_CATEGORY_DEFS.map(({ id, name, color }) => ({
  id,
  name,
  color,
}));

/** Numeric ids the API uses, keyed the way code branches on them — mirrors
 * `PROCESSING_STATUS`/`REVIEW_STATUS` in statusEnums.js. */
export const INVOICE_CATEGORY = Object.fromEntries(
  INVOICE_CATEGORY_DEFS.map(({ key, id }) => [key, id]),
);

export function getInvoiceCategory(id) {
  return INVOICE_CATEGORIES.find((category) => category.id === Number(id)) ?? null;
}

export function getInvoiceCategoryColor(id) {
  return getInvoiceCategory(id)?.color ?? "#6c757d";
}
